// Live ad-serving "source" — the ott_id that adaptek sends on each VAST request.
// It is stored verbatim in the `vast.platform` column (see resolveRecord:
// `platform: record.ott_id`), so segment filters target it via the `platform`
// field with these numeric-string keys as the value.
//
// Keyed by the ott_id string exactly as it appears in traffic; value carries the
// human label and the source's primary domain.
export const OTT_SOURCES = new Map([
  ["10", { name: "Omega TV", domain: "omegatv.ua" }],
  ["11", { name: "You TV & Triolan TV", domain: "youtv.ua" }],
  ["14", { name: "Lifecell TV (Volia)", domain: "tv.lifecell.ua" }],
  ["15", { name: "ProstoTV", domain: "prosto.tv" }],
  ["16", { name: "Kyivstar", domain: "tv.kyivstar.ua" }],
  ["17", { name: "SweetTV", domain: "sweet.tv" }],
]);
